import { useState } from 'react';

import { ActionModal, IActionModalProps } from './action-modal/action-modal';
import { ActionModalContextProvider } from './context/action-modal-context';

interface IActionModalProviderProps {
  children: React.ReactNode;
}

export const ActionModalProvider = ({
  children,
}: IActionModalProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalProps, setModalProps] = useState<
    Omit<IActionModalProps, 'isOpen' | 'onClose'>
  >({});

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <ActionModalContextProvider
      model={{
        onOpen: handleOpen,
        onClose: handleClose,
        onSetModalProps: setModalProps,
      }}
    >
      {children}
      <ActionModal isOpen={isOpen} onClose={handleClose} {...modalProps} />
    </ActionModalContextProvider>
  );
};
